import React, { useState } from 'react';
import { Send, Phone, Mail, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <section id="kontakt" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8">
        <div className="bg-slate-50 overflow-hidden sm:shadow-xl border-y sm:border border-slate-100">
          <div className="flex flex-col lg:flex-row">
            {/* Contact Info */}
            <div className="lg:w-2/5 bg-orange-600 p-6 sm:p-8 text-white relative overflow-hidden">
              {/* Brick Watermark */}
              <div className="absolute inset-0 opacity-10 pointer-events-none">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                  <pattern id="brick-pattern" x="0" y="0" width="100" height="50" patternUnits="userSpaceOnUse">
                    <rect width="100" height="50" fill="none" />
                    <path d="M0 25h100M50 0v25M25 25v25M75 25v25" stroke="white" strokeWidth="2" fill="none" />
                  </pattern>
                  <rect width="100%" height="100%" fill="url(#brick-pattern)" />
                </svg>
              </div>

              <div className="relative z-10">
                <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-white">Kontakt os i dag</h2>
                <p className="text-white text-sm sm:text-base mb-6 sm:mb-8 leading-relaxed opacity-90">
                  Har du et projekt i tankerne? Vi står klar til at rådgive dig og give et uforpligtende tilbud på din opgave.
                </p>

                <div className="space-y-4 sm:space-y-6">
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="p-2 bg-white/10 rounded-lg">
                      <Phone className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <p className="text-white/70 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-0.5">Ring til os</p>
                      <p className="text-lg sm:text-xl font-bold">+45 61 67 83 52</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="p-2 bg-white/10 rounded-lg">
                      <Mail className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <p className="text-white/70 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-0.5">Send en mail</p>
                      <p className="text-base sm:text-lg font-bold">steffanlund@gmail.com</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="p-2 bg-white/10 rounded-lg">
                      <MapPin className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <p className="text-white/70 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-0.5">Besøg os</p>
                      <p className="text-base sm:text-lg font-bold">Strucksalle 36, 6270 Tønder</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="p-2 bg-white/10 rounded-lg">
                      <Clock className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <p className="text-white/70 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-0.5">Åbningstider</p>
                      <p className="text-base sm:text-lg font-bold">Man - Fre: 07:00 - 16:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="lg:w-3/5 p-6 sm:p-8 bg-white">
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Honeypot */}
                <div className="sr-only absolute">
                  <label htmlFor="website_url">Website URL</label>
                  <input type="text" id="website_url" name="website_url" tabIndex="-1" />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label htmlFor="name" className="text-sm font-bold text-slate-700">Navn</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-slate-200 focus:ring-2 focus:ring-orange-600 focus:border-transparent outline-none transition-all"
                      placeholder="Dit navn"
                    />
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="email" className="text-sm font-bold text-slate-700">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-slate-200 focus:ring-2 focus:ring-orange-600 focus:border-transparent outline-none transition-all"
                      placeholder="din@email.dk"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label htmlFor="phone" className="text-sm font-bold text-slate-700">Telefon</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-slate-200 focus:ring-2 focus:ring-orange-600 focus:border-transparent outline-none transition-all"
                    placeholder="Dit telefonnummer"
                  />
                </div>

                <div className="space-y-2">
                  <label htmlFor="subject" className="text-sm font-bold text-slate-700">Emne</label>
                  <select
                    id="subject"
                    name="subject"
                    className="w-full px-4 py-3 border border-slate-200 focus:ring-2 focus:ring-orange-600 focus:border-transparent outline-none transition-all"
                  >
                    <option>Flisearbejde</option>
                    <option>Murerarbejde</option>
                    <option>Reparation</option>
                    <option>Andet</option>
                  </select>
                </div>

                <div className="space-y-2">
                  <label htmlFor="message" className="text-sm font-bold text-slate-700">Besked</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    required
                    className="w-full px-4 py-3 border border-slate-200 focus:ring-2 focus:ring-orange-600 focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Beskriv dit projekt..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={status === 'sending'}
                  className={`w-full py-4 rounded-xl font-bold text-lg flex items-center justify-center space-x-2 transition-all ${
                    status === 'sending'
                      ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                      : 'bg-orange-600 text-white hover:bg-orange-700'
                  }`}
                >
                  <span>{status === 'sending' ? 'Sender...' : 'Send besked'}</span>
                  <Send className="h-5 w-5" />
                </button>

                {status === 'success' && (
                  <p className="text-green-600 font-medium text-center bg-green-50 py-3 border border-green-100">
                    Tak for din besked! Vi vender tilbage hurtigst muligt.
                  </p>
                )}
                {status === 'error' && (
                  <p className="text-red-600 font-medium text-center bg-red-50 py-3 border border-red-100">
                    Der skete en fejl. Prøv venligst igen eller ring til os.
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
